<template>
<div class="chapter">
<div class="inner_page">
<p class="ded1"><a id="page_v"></a><em class="italic">To my parents,</em></p>
<p class="ded2"><em class="italic">Curtiss and Patricia Hall</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Dedication.vue?73b0ed82